import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-diagram',
  templateUrl: './diagram.component.html',
  styleUrls: ['./diagram.component.scss']
})
export class DiagramComponent implements OnInit {

  diagram: SafeHtml;
  title: string;

  constructor(public dialogRef: MatDialogRef<DiagramComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private sanitizer: DomSanitizer) {
  }

  ngOnInit() {
    /*
    const parser = new DOMParser();
    const xml = parser.parseFromString(this.data.diagram, 'application/xml');
    */
    this.diagram = this.sanitizer.bypassSecurityTrustHtml(this.data.diagram);
    this.title = this.data.title;
  }

}
